/** Mulberry32: small, fast, deterministic PRNG */
export function mulberry32(seed: number) {
    let a = seed >>> 0;
    return function rand() {
        a |= 0;
        a = (a + 0x6d2b79f5) | 0;
        let t = Math.imul(a ^ (a >>> 15), 1 | a);
        t ^= t + Math.imul(t ^ (t >>> 7), 61 | t);
        return ((t ^ (t >>> 14)) >>> 0) / 4294967296;
    };
}

export function randint(rnd: () => number, min: number, max: number) {
    // inclusive
    return Math.floor(rnd() * (max - min + 1)) + min;
}

export function clamp(n: number, lo: number, hi: number) {
    return Math.max(lo, Math.min(hi, n));
}
